import { useCallback, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { initiateInstagramConnection } from '@/lib/api'
import ConnectPlatform from '@/components/ConnectPlatform'

const InstagramConnect = () => {
  const [connecting, setConnecting] = useState(false)
  const stopConnecting = useCallback(() => setConnecting(false), [])
  // The backend sends the athlete back here when this instance can't connect Instagram
  const notAvailable = useSearchParams()[0].get('error') === 'not_available'

  const handleConnect = async () => {
    setConnecting(true)
    try {
      await initiateInstagramConnection()
    } catch (error) {
      console.error('Failed to initiate Instagram connection:', error)
      setConnecting(false)
    }
  }

  return (
    <ConnectPlatform
      slug="instagram"
      name="Instagram"
      iconBg="linear-gradient(135deg, #FF3A89, #FFC702)"
      shows="Brands see your real followers and engagement, so you get better offers."
      buttonLabel="Connect Instagram"
      onConnect={handleConnect}
      connecting={connecting}
      onReturn={stopConnecting}
      requirement={{
        text: 'Needs a Business or Creator account.',
        linkLabel: 'How to switch',
        href: 'https://help.instagram.com/502981923235522',
      }}
      unavailable={
        notAvailable ? "Instagram can't be connected here yet. You can add it later." : undefined
      }
    />
  )
}

export default InstagramConnect
